import './Social.css';
/* PENDING IMPROVEMENTS:
- handle color selection (currently done in css)
- handle absolute positioning
*/
function Social({ justify = "start", size = "inherit", iconMargin = null }) {
  
  const socials = [
    { url: 'https://twitter.com/CanuckzNFT', fa: 'twitter' },
    { url: 'https://discord.com/invite/e8M5GHpycZ', fa: 'discord' },
  ]

  const socialStyles = {
    justifyContent: justify,
    fontSize: size
  }
  const linkStyles = {
    margin: iconMargin
  };

  return (
    <div className="social" style={socialStyles}>
      {socials.map((s) => (
        <a href={s.url} className="social-link" style={linkStyles}>
          <i className={`fab fa-${s.fa}`}></i>
        </a>
      ))}
      {/* <a href="https://www.instagram.com/wildwarriors_NFT/" className="social-link">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="https://twitter.com/WildWarriorsNFT" className="social-link" >
        <i className="fab fa-twitter" style={iconStyles}></i>

      </a>
      <a href="https://discord.com/invite/hBZy8uDU" className="social-link">
        <i className="fab fa-discord"></i>
      </a> */}

    </div>
  );
}

export default Social;